// Runtime webpack config
import '../../other/WebpackConfig';

import '../../../scss/l1CarsSellPage.mp.nlnl.scss';

// i18n
import i18n from '../../i18n/nl-NL';

import l1CarsSellPage from './l1CarsSellPage';

l1CarsSellPage(i18n);
